var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6276 5.91172L10.368 5.65876C10.368 5.65876 10.7487 6.59832 10.4546 7.37527C10.1604 8.15221 9.31248 7.80891 9.399 7.17651C9.71048 4.95409 9.60665 1.71983 5.14209 0.0213879C4.53643 -0.285777 7.0802 2.7678 2.82329 5.82138C-1.22596 8.7304 0.227615 12.3441 0.366051 12.6874C0.366051 12.7055 0.383355 12.7235 0.383355 12.7416L6.07653 22.7696C6.24958 23.0768 6.66489 23.0768 6.83793 22.7696L12.3581 12.8139C12.3754 12.7958 14.0366 9.52542 10.6276 5.91172ZM6.38802 16.0843C5.09018 16.0843 4.0346 14.3678 4.0346 12.2538C4.0346 10.1397 5.09018 8.42324 6.38802 8.42324C7.68585 8.42324 8.74143 10.1397 8.74143 12.2538C8.74143 14.3678 7.68585 16.0843 6.38802 16.0843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledRating);
export default __webpack_public_path__ + "static/media/FilledRating.8c66cbe9c39df6f7439c214a79f4c5c4.svg";
export { ForwardRef as ReactComponent };